import { createFileRoute } from '@tanstack/react-router'
import AccessTable from '../../../../../views/Admin/AccessTable/AccessTable'
import React from 'react'
import { generateRandomString } from '../../../../utils'
import { AssettrakAccess } from 'server'
import { getAllData } from '../../../../../utils/data'
import useRouteLog from '../../../../hooks/useRouteLog'
import useListener from '../../../../hooks/useListener'
import { adminAuth } from '../../../../hooks/beforeLoad/adminAuth'
import LoadingScreen from '../../../../LoadingScreen/LoadingScreen'

export const Route = createFileRoute('/admin/_layout/access/')({
  beforeLoad: adminAuth,
  pendingComponent: () => <LoadingScreen />,
  loader: async ({ context }) => {
    const rsg = generateRandomString()
    const label = `/admin/_layout/access/index.tsx loader: ${rsg}`
    console.time(label)

    const { client, queryClient } = context

    /* Assettrak Access */
    const assettrakAccessQuery = {
      $sort: {
        last_login: -1
      }
    }
    const assettrakAccess = await queryClient.ensureQueryData({
      queryKey: ['assettrak-access', 'find', assettrakAccessQuery],
      queryFn: () => getAllData(client, 'assettrak-access', assettrakAccessQuery)
    })

    const uniqueAgencyIds = Array.from(
      new Set(
        assettrakAccess
          .map((ata: AssettrakAccess) =>
            ata.allowed_agencies.split(',').map((agencyId: string) => parseInt(agencyId))
          )
          .flat()
      )
    )

    /* Agencies */
    const agenciesQuery = {
      id: {
        $in: uniqueAgencyIds
      }
    }
    const agencies = await queryClient.ensureQueryData({
      queryKey: ['agencies', 'find', agenciesQuery],
      queryFn: () => getAllData(client, 'agencies', agenciesQuery)
    })

    /* Vehicles */
    const vehiclesQuery = {
      agency_id: {
        $in: uniqueAgencyIds
      }
    }
    const vehicles = await queryClient.ensureQueryData({
      queryKey: ['vehicle', 'find', vehiclesQuery],
      queryFn: () => getAllData(client, 'vehicle', vehiclesQuery)
    })

    console.timeEnd(label)

    return {
      assettrakAccess,
      agencies,
      vehicles
    }
  },
  component: RouteComponent
})

function RouteComponent() {
  useRouteLog('/admin/_layout/access/')
  useListener('assettrak-access')
  useListener('agencies')
  useListener('vehicle')
  return <AccessTable />
}
